import { makeAutoObservable, action } from "mobx";
import { Category } from "../types";
import { RootStore } from "./root.store";
import CategoryService from "../services/category.service";
export class CategoryStore {
  rootStore: RootStore;
  loaded: boolean = false;
  loading: boolean = false;
  videoData: Category[] = [];
  imageData: Category[] = [];
  error: string | null = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
    // Auto-fetch categories unless on a public share page
    if (!window.location.pathname.includes("/shares/")) {
      this.getAll();
    }
  }

  async getAll(refresh?: boolean): Promise<Category[]> {
    this.error = null;
    this.loading = true;
    this.videoData = [];
    this.imageData = [];

    try {
      const [videoResponse, imageResponse] = await Promise.all([
        CategoryService.fetchAll({ pageSize: 1000, pageNumber: 1, resourceType: "Video" }),
        CategoryService.fetchAll({ pageSize: 1000, pageNumber: 1, resourceType: "Image" }),
      ]);
      this.videoData = videoResponse.data;
      this.imageData = imageResponse.data;
      this.loaded = true;
      return [...this.videoData, ...this.imageData];
    } catch (error: any) {
      const msg = error?.message || String(error);
      this.error = msg;
      console.error("Error fetching categories:", msg);
      return [];
    } finally {
      this.loading = false;
    }
  }

  addUpdateItem(category: Category): void {
    const target = category.resource_type === "Image" ? this.imageData : this.videoData;
    const categoryIndex = target.findIndex((c) => c.id === category.id);
    if (categoryIndex >= 0) {
      target[categoryIndex] = category;
    } else {
      if (category.resource_type === "Image") {
        this.imageData = [...this.imageData, category];
      } else {
        this.videoData = [...this.videoData, category];
      }
    }
  }
}
